import { Injectable } from '@angular/core';
import { ShiftValidationDetails } from '@wilson/interfaces';
import { ValidationDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { Observable, of } from 'rxjs';

@Injectable()
export class DraftTimelineValidationDataSourceServiceService extends ValidationDataSourceService {
  constructor() {
    super();
  }

  override hasShiftValidated(): Observable<boolean> {
    return of(false);
  }

  override isShiftOfUserValidated(): Observable<boolean> {
    return of(false);
  }

  override isCurrentUserValidationLoading(): Observable<boolean> {
    return of(false);
  }

  override shiftValidationStreamForAssignedShifts(): Observable<
    ShiftValidationDetails[] | undefined
  > {
    return of(undefined);
  }

  override shiftValidationStreamForUnassignedShifts(): Observable<
    ShiftValidationDetails[] | undefined
  > {
    return of(undefined);
  }

  override isLoadingValidationsError(): Observable<boolean> {
    return of(false);
  }

  override isLoadingValidationsV1Error(): Observable<boolean> {
    return of(false);
  }

  override isShiftValidationLoadingForAssignedShifts(): Observable<boolean> {
    return of(false);
  }

  override isShiftValidationLoadingForUnassignedShifts(): Observable<boolean> {
    return of(false);
  }
}
